export default __webpack_public_path__ + "static/media/18-stakeholder-map-1.c45f5ab6.svg";